import Image from "next/image"
import teams from "./teams.json"

const RenderTeams = () => {
    return (
        <div className="flex flex-row  rounded-2xl select-none h-[200px] ">
            {/* Add ring overlays */}

            {teams.map((img, index) => (
                <div key={index} className="w-[350px] h-[35px]">
                    <div className="absolute inset-0 z-10 rounded-[5px]" />
                    <Image
                        src={"https://passticketsstorage.blob.core.windows.net/images/f1-2025" + img}
                        alt={`F1 Team ${index + 1}`}
                        width={350}
                        height={350}
                        style={{
                            objectFit: "contain",
                            // height: "350px",
                        }}
                    />
                </div>


            ))}

        </div>
    )
}

export default RenderTeams
